<template>
  <SvgBase width="24" height="24" viewBox="0 0 24 24" fill="none">
    <title>RFID Power Low</title>
    <path
      d="M8 16C8 14.3431 9.34315 13 11 13H13C14.6569 13 16 14.3431 16 16"
      :stroke="color"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <circle cx="12" cy="19" r="1.5" :fill="color" />
  </SvgBase>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import SvgBase from './SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
})
export default class IconRfidPowerLow extends Vue {}
</script>
